import React from "react";
import { Shield, ArrowRight } from "lucide-react";
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose, returnUrl }) => {
  const handleGoogleLogin = () => {
    const backendUrl = window.location.origin;
    window.location.href = `${backendUrl}/api/auth/google/login`;
  };

  if (!isOpen) return null;

  return (
    <div className="lm-overlay" onClick={onClose} data-testid="login-modal-overlay">
      <div className="lm-card" onClick={(e) => e.stopPropagation()} data-testid="login-modal">
        {/* Close */}
        <button className="lm-close" onClick={onClose} data-testid="login-modal-close" aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
        </button>

        {/* Branding strip */}
        <div className="lm-brand">
          <img src="/logo192.png" alt="taskeri®" className="lm-logo" onError={(e) => { e.target.style.display = 'none'; }} />
        </div>

        {/* Content */}
        <div className="lm-body">
          <h2 className="lm-title">Welcome back</h2>
          <p className="lm-sub">Sign in to access your dashboard</p>

          <button className="lm-google" onClick={handleGoogleLogin} data-testid="login-google-btn">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
              <path d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707 0-.593.102-1.17.282-1.709V4.958H.957C.347 6.173 0 7.548 0 9c0 1.452.348 2.827.957 4.042l3.007-2.335z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
            </svg>
            <span>Continue with Google</span>
            <ArrowRight size={16} className="lm-arrow" />
          </button>

          <div className="lm-trust">
            <Shield size={13} />
            <span>256-bit encrypted &middot; No password needed</span>
          </div>
        </div>

        {/* Footer */}
        <div className="lm-footer">
          <p>By signing in, you agree to our <a href="/terms">Terms</a> and <a href="/privacy">Privacy Policy</a></p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;

